import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportTable from './ReportTable';
import Actions from '../../../../Actions';

class TabularReport extends Component {
    constructor(props){
        super(props);
    }


    report = () => {
        const { getReports, auth, reportId } = this.props;
        getReports(auth.token,{ sort: "total", order: "desc" },reportId);
    }

    componentDidMount = () => {
        this.report();
    }

    render(){
        const { reportId } = this.props;

        return <ReportTable reportId={reportId} />;
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, Actions.reports)(TabularReport);


// WEBPACK FOOTER //
// ./src/Components/App/Reports/TabularReport/index.js